export default function buildAnalyseBarConfig (legend, xAxis, data, unit) {
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color: ['#FAAA00', '#4DCBCB', '#F3667C', '#1990FF', '#6300BF', '#7B4D12', '#F2919E', '#828116'],
    legend: {
      data: legend
    },
    title: {
      text: '单位:' + unit,
      left: '120',
      top: '10',
      textStyle: {
        fontSize: 14,
        fontStyle: 'normal',
        color: 'gray'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      show: true,
      top: '10',
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        dataView: {show: false},
        restore: {},
        saveAsImage: {}
      }
    },
    xAxis: [
      {
        type: 'category',
        data: xAxis
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: data
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/congif_analyse_bar.js